module.exports = __webpack_public_path__ + "img/0Q3A4612_L_Black.efb1b321.jpg";